<template>
    <div :class="{'modal': true, 'show': showModal}"
         ref="modal"
         tabindex="-1"
         role="dialog">
        <div class="modal-dialog  full-screen"
             :class="{'modal-big': big}"
             role="document">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <h3 class="modal-title text-center">{{title}}</h3>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <slot name="body"></slot>
                        </div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-6 m-auto" v-if="showSave">
                        <button name="save"
                                class="btn btn-cph btn-success d-block m-auto"
                                @click="$emit('save')" >
                            {{$t(saveText)}}
                        </button>
                    </div>
                    <div class="col-6 m-auto" v-if="showClose">
                        <button name="close"
                                class="btn btn-cph btn-info d-block m-auto"
                                @click="closeModal(false)">
                            {{$t(closeText)}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
/**
 * @module Legal/Modal
 * @description modal component for displaying terms and conditions on start page
 * */
export default {
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        showSave: {
            type: Boolean,
            default: false
        },
        showClose: {
            type: Boolean,
            default: true
        },
        big: {
            type: Boolean,
            default: false
        },
        closeText: {
            type: String,
            default: "COMMON.close"
        },
        saveText: {
            type: String,
            default: "UI.save"
        }
    },
    methods: {
        closeModal () {
            this.$emit('close');
        }
    },
    mounted () {
        this.$refs.modal.addEventListener('scroll', (e) => e.stopPropagation());
    },
    beforeDestroy () {
        this.$refs.modal.removeEventListener('scroll', (e) => e.stopPropagation());
    }
};

</script>

<style lang="scss" scoped>
    .modal-dialog {
        @include margin-auto;
        &.modal-big {
            max-width: 90vw;
        }
    }

    .modal-content {
        overflow: hidden;
    }

    .modal-body {
        padding-top: 0;
        color: #000;
        min-height: 50vh;
        max-height: 80vh;
        overflow-y: auto;
    }

    .show {
        display: block !important;
    }

    .modal-header {
        position: relative;
        height: $standard-height;
        @include color('color', text-color-light);
        //@include color('background-color', primary);
    }

    button.close {
        position: absolute;
        right: 2rem;
        top: 2rem;
        font-size: 1em;
        opacity: 0.7;
    }


    .modal::before, .modal::after {
        position: absolute;
        @include color('background-color', darker-secondary);
        content: "";
        left: 0;
        top: 0;
        width: 150%;
        height: 150%;
        z-index: -10;
        opacity: 0.3;
    }

    .modal-title {
        color: black;
    }

</style>
